<template>
    <app-layout>
        <div class="products-layout">
            <v-list>
                <inertia-link href="/backoffice/products">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.products')}">
                        <v-list-item-content>
                            <v-list-item-title>{{$page.props.lang.menu_products || "Products"}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </inertia-link>
                <inertia-link href="/backoffice/categories">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.categories')}">
                        <v-list-item-content>
                            <v-list-item-title>{{$page.props.lang.menu_categories || "Categories"}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </inertia-link>
            </v-list>
            <div class="slot-card">

                <slot></slot>
                
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'

export default {
    name: "ProductsLayout",
    components: {
        AppLayout
    },
    data() {
        return {

        }
    }
}
</script>